import {SearchRuleListItem} from '../../../integrated-client/models/';

interface ITableData {
  records: Array<SearchRuleListItem>
  totalItems?: number
}

export class TableData implements ITableData{
  records: Array<SearchRuleListItem>
  totalItems?: number

  constructor() {
    this.records = [];
  }

}
